module.exports = __webpack_public_path__ + "img/mockups-remerciement-mobile.cbed2c4.png";